module.exports = __webpack_public_path__ + "static/media/team-erin.7e8c44c3.jpg";